import dayjs from "dayjs";

export const generateCertificateNumber = (empId) => {
  return `CERT/${dayjs().year()}/${empId}/${Math.floor(1000 + Math.random() * 9000)}`;
};

export const getPronoun = (gender, type) => {
  const map = {
    Male: { sub: "he", obj: "him", pos: "his" },
    Female: { sub: "she", obj: "her", pos: "her" }
  };
  return map[gender]?.[type] || "they";
};
